module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres5-89bf4dca8e6da32789302b83e1a032b1.jpg";